<template>
	<div class="app-wrapper el-container is-vertical">
		<navbar class="main-header el-header" />
		<div class="main-container el-container" v-bind:class="{ 'sidebar-mini': !sidebar.opened }">
			<sidebar class="main-sidebar el-aside" ref="mainSidebar" />
			<AppMain class="content-container" ref="mainContent" />
		</div>
	</div>
</template>

<script>
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import AppMain from './AppMain'

export default {
	name: 'layout',
	components: {
		Navbar,
		Sidebar,
		AppMain
	},
	computed: {
		sidebar() {
			return this.$store.state.app.sidebar
		}
	},
	mounted() {}
}
</script>
